module.exports = __webpack_public_path__ + "img/img_index_cha_02@2x.7ed9d16a.png";